import React, { useState, useEffect } from "react";
import { Quill } from "react-quill";
import BackgroundFormat from  '../TextBlockToolbar/BackgroundFormat'
import ColorFormat from  '../TextBlockToolbar/ColorFormat'
import { Tooltip } from "antd";
import { TEXT_BLOCK_TOOLBAR } from "../../../artboard/Toolbar/translationValues";
import { CUSTOM_TOOLBAR_TOOLTIP } from "./translationValues";

const Expand = () =>{
  
  return(
    <svg fill="#ffffff" width="20px" height="20px" viewBox="0 0 48 48" >
    <g id="Layer_2" data-name="Layer 2">
      <g id="invisible_box" data-name="invisible box">
        <rect width="48" height="48" fill="none"/>
      </g>
      <g id="icons_Q2" data-name="icons Q2">
        <g>
          <path d="M18.6,26.6,8,37.2V30.1A2.1,2.1,0,0,0,6.3,28,2,2,0,0,0,4,30V42a2,2,0,0,0,2,2H17.9A2.1,2.1,0,0,0,20,42.3,2,2,0,0,0,18,40H10.8L21.3,29.5a2.1,2.1,0,0,0,.3-2.7A1.9,1.9,0,0,0,18.6,26.6Z"/>
          <path d="M30,4a2,2,0,0,0-2,2.3A2.1,2.1,0,0,0,30.1,8h7.1L26.7,18.5a2,2,0,0,0-.2,2.8A1.8,1.8,0,0,0,28,22a2,2,0,0,0,1.4-.6L40,10.8v7.1A2.1,2.1,0,0,0,41.7,20,2,2,0,0,0,44,18V6a2,2,0,0,0-2-2Z"/>
        </g>
      </g>
    </g>
  </svg>
);}

const Resize = () => (
 
<svg fill="#ffffff" width="20px" height="20px" viewBox="0 0 36 36" version="1.1"  preserveAspectRatio="xMidYMid meet">
    <path class="clr-i-outline clr-i-outline-path-1" d="M32,15H22.41l9.25-9.25a1,1,0,0,0-1.41-1.41L21,13.59V4a1,1,0,0,0-2,0V17H32a1,1,0,0,0,0-2Z"></path><path class="clr-i-outline clr-i-outline-path-2" d="M4,19a1,1,0,0,0,0,2h9.59L4.33,30.25a1,1,0,1,0,1.41,1.41L15,22.41V32a1,1,0,0,0,2,0V19Z"></path>
    <rect x="0" y="0" width="36" height="36" fill-opacity="0"/>
</svg>
);

const Size = Quill.import("formats/size");
Size.whitelist = ["extra-small", "small", "medium", "large"];
Quill.register(Size, true);

const Font = Quill.import("formats/font");
Font.whitelist = [
  "arial",
  "comic-sans",
  "courier-new",
  "georgia",
  "helvetica",
  "lucida",
  "Times New Roman",
  "Lato"
];

Quill.register(Font, true);
const AlignStyle = Quill.import('attributors/style/align');
Quill.register(AlignStyle, true);

export const modules = (varName) => ({
  toolbar: {
    container: `#htmltoolbar-${varName}`,
  },
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true
  },
  clipboard: {
    matchVisual: false,
  },

});

const CustomToolBar = props =>{
  const {t,setIsHtmlExpanded,isHtmlExpanded,varName,setExpandedVariablesList,expandedVariablesList,editorRef,onSave, isTemplateDescription, isdescriptionSaved, isInteractiveDesign} = props;
  let currentArray;
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let timer;
    if (isdescriptionSaved) {
      setIsVisible(true);

      timer = setTimeout(() => {
        setIsVisible(false);
      }, 2000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [isdescriptionSaved]);

  const handleClick = () => {
    setTooltipVisible(false)
    setExpandedVariablesList(prevState => {
      if (prevState.includes(`tool-${varName}`)) {
        currentArray = prevState.filter(item => item !== `tool-${varName}`);
      } else {
        currentArray = [...prevState, `tool-${varName}`];
      }
      setIsHtmlExpanded(currentArray?.length > 0 ? true : false)
      return currentArray;
    });
  }
  
  const [tooltipVisible, setTooltipVisible] = useState(false);

  return(
    <div id={`htmltoolbar-${varName}`} style={{display: isInteractiveDesign && 'none'}}>
              {/* <button onClick={onSave}>save</button> */}
      <div className=" ql-custom-tray" style={{ flexWrap: 'wrap' }}>
        <span className="ql-formats hide-bar">
          <BackgroundFormat itemUUID={varName} editorRef={editorRef} toolbar={'htmltoolbar'} />
        </span>
        <span className="ql-formats hide-bar">
          <ColorFormat itemUUID={varName} editorRef={editorRef} toolbar={'htmltoolBar'} />
        </span>
        <Tooltip
          placement="top"
          title={t(
            TEXT_BLOCK_TOOLBAR.TEXT_ITALIC_TOOLTIP.key,
            TEXT_BLOCK_TOOLBAR.TEXT_ITALIC_TOOLTIP.value,
          )}>
          <span className="ql-formats">
            <button className="ql-italic" />
          </span>
        </Tooltip>
        <Tooltip
          placement="top"
          title={t(
            TEXT_BLOCK_TOOLBAR.TEXT_UNDERLINE_TOOLTIP.key,
            TEXT_BLOCK_TOOLBAR.TEXT_UNDERLINE_TOOLTIP.value,
          )}>
          <span className="ql-formats">
            <button className="ql-underline" />
          </span>
        </Tooltip>
        <Tooltip
          placement="top"
          title={t(
            TEXT_BLOCK_TOOLBAR.TEXT_BOLD_TOOLTIP.key,
            TEXT_BLOCK_TOOLBAR.TEXT_BOLD_TOOLTIP.value,
          )}>
          <span className="ql-formats">
            <button className="ql-bold" />
          </span>
        </Tooltip>
        <Tooltip
          placement="top"
          title={t(
            CUSTOM_TOOLBAR_TOOLTIP.TEXT_ALIGNMENT_TOOLTIP.key,
            CUSTOM_TOOLBAR_TOOLTIP.TEXT_ALIGNMENT_TOOLTIP.value,
          )}>
          <span className="ql-formats">
            <select className="ql-align" />
          </span>
        </Tooltip>
        <Tooltip
          placement="top"
          title={t(
            TEXT_BLOCK_TOOLBAR.TEXT_NUMBERED_LIST_TOOLTIP.key,
            TEXT_BLOCK_TOOLBAR.TEXT_NUMBERED_LIST_TOOLTIP.value,
          )}>
          <span className="ql-formats">
            <button className="ql-list" value="ordered" />
          </span>
        </Tooltip>
        <Tooltip
          placement="top"
          title={t(
            TEXT_BLOCK_TOOLBAR.TEXT_BULLETED_LIST_TOOLTIP.key,
            TEXT_BLOCK_TOOLBAR.TEXT_BULLETED_LIST_TOOLTIP.value,
          )}>
          <span className="ql-formats">
            <button className="ql-list" value="bullet" />
          </span>
        </Tooltip>
       { !isTemplateDescription ? <Tooltip onVisibleChange={(visible) => setTooltipVisible(visible)}
          visible={tooltipVisible}
          placement="top"
          title={isHtmlExpanded && (expandedVariablesList.includes(`tool-${varName}`)) ? t(
            CUSTOM_TOOLBAR_TOOLTIP.MINIMIZE_TOOLTIP.key,
            CUSTOM_TOOLBAR_TOOLTIP.MINIMIZE_TOOLTIP.value,
          ) : t(
            CUSTOM_TOOLBAR_TOOLTIP.EXPAND_TOOLTIP.key,
            CUSTOM_TOOLBAR_TOOLTIP.EXPAND_TOOLTIP.value,
          )
          }>
            <span className="ql-formats">
              <button className="ql-undo" onClick={handleClick}>
                {isHtmlExpanded && (expandedVariablesList.includes(`tool-${varName}`)) ? <Resize /> : <Expand />}
              </button>
            </span>
          
        </Tooltip>:
          <span className="ql-formats" style={{ float: 'right' }}>
            <button 
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '49px',
                width: '91px',
                height: '33px',
                float: 'right',
                backgroundColor: isVisible ? 'green' : '#FFEB3B',
                color: isVisible ? 'white' : 'black',
                overflow: 'hidden', 
                position: 'relative',
                transition: 'background-color 0.3s ease, color 0.3s ease',
              }}
             disabled={isVisible} onClick={onSave}>
              <span
                style={{
                  position: 'absolute',
                  transition: 'transform 0.3s ease, opacity 0.3s ease',
                  transform: isVisible ? 'translateY(0)' : 'translateY(100%)',
                  opacity: isVisible ? 1 : 0,
                }}
              >
                {t(
                  CUSTOM_TOOLBAR_TOOLTIP.SAVED_BUTTON.key,
                  CUSTOM_TOOLBAR_TOOLTIP.SAVED_BUTTON.value,
                )}
              </span>
              <span
                style={{
                  position: 'absolute',
                  transition: 'transform 0.3s ease, opacity 0.3s ease',
                  transform: isVisible ? 'translateY(-100%)' : 'translateY(0)',
                  opacity: isVisible ? 0 : 1,
                }}
              >
                {t(
                  CUSTOM_TOOLBAR_TOOLTIP.SAVE_BUTTON.key,
                  CUSTOM_TOOLBAR_TOOLTIP.SAVE_BUTTON.value,
                )}    
               </span>
            </button>
          </span>          
        }
      </div>
    </div>
  )};

export default CustomToolBar;